import { useStoreStatus } from "@/context/StoreStatusContext";

/**
 * "Free cookie for the first 100 customers" banner.
 * Renders on Home and Cart. Silent when the promo is inactive or fully claimed.
 * Pass `variant="compact"` for the cart summary; default is the home hero style.
 */
export default function LaunchPromoBanner({ variant = "default" }) {
  const { launchPromo } = useStoreStatus();
  if (!launchPromo?.is_active) return null;
  if (!launchPromo.remaining) return null;

  const { remaining, limit } = launchPromo;
  const pct = Math.max(4, Math.round((remaining / limit) * 100));

  if (variant === "compact") {
    return (
      <div
        data-testid="launch-promo-banner-compact"
        className="border border-gold/50 bg-gold/5 px-4 py-3 rounded-sm"
      >
        <div className="flex items-baseline justify-between gap-3">
          <p className="font-serif italic text-espresso text-sm">A free launch cookie is in your basket.</p>
          <span className="label-xs text-gold-hover whitespace-nowrap" data-testid="launch-promo-remaining">
            {remaining} of {limit} left
          </span>
        </div>
        <div className="mt-2 h-1 w-full bg-line/60 rounded">
          <div className="h-1 bg-gold rounded" style={{ width: `${pct}%` }} />
        </div>
      </div>
    );
  }

  return (
    <div
      data-testid="launch-promo-banner"
      className="border-y border-gold/40 bg-gold/10 px-4 py-2 text-center sm:py-3"
    >
      <p className="font-serif text-xs tracking-wide text-espresso sm:text-sm md:text-base">
        <span className="hidden italic sm:inline">Launch gift · </span>
        <span className="hidden sm:inline">A complimentary cookie with your order. Only </span>
        <span className="sm:hidden">Free cookie · </span>
        <span className="font-semibold" data-testid="launch-promo-remaining">
          {remaining} of {limit}
        </span>{" "}
        left.
      </p>
    </div>
  );
}
